import React, { Suspense } from 'react'
import './homeHero.sass'
import { lazyWithRetry } from 'components/lazyUtil.js'
import { Columns } from 'components/elements'

const HomeSearchBar = lazyWithRetry(() => import('../homeSearchBar.js'))

const renderLoader = () => <span></span>

const HomeHero = ({ isMobile }) => (
  <Suspense fallback={renderLoader()}>
    <div
      className="home-page-hero-wrap"
      style={{
        backgroundImage: `url("${
          isMobile
            ? 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/heroImageMobile.jpg'
            : 'https://res.cloudinary.com/twisted-road/image/upload/q_auto,f_auto/v1572480187/frontend_assets/motoHome.jpg'
        }")`,
      }}
      data-nosnippet
    >
      <div className="container small">
        <Columns className="is-vcentered">
          <Columns.Column>
            <div className="has-text-centered">
              <h1 className="home-page-cta">
                <span className="home-header-eyebrow">
                  Motorcycle Renting & Sharing
                </span>
              </h1>
              <h2>
                <span className="home-header-main is-block">RENT A BIKE.</span>
                <span className="home-header-main is-block">
                  RIDE THE WORLD.
                </span>
              </h2>
            </div>
            <div className="">
              <HomeSearchBar />
            </div>
          </Columns.Column>
        </Columns>
      </div>
    </div>
  </Suspense>
)

export default HomeHero
